import './ccf-acd-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAcdIconProps extends SvgIconProps {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfAcdIcon(props: CcfAcdIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fill="#e68500"
        d="M29.711 15.859l-5.739-5.74c-0.036-0.036-0.086-0.059-0.142-0.059-0.111 0-0.199 0.090-0.199 0.201 0 0 0 0 0 0v0 2.139h-21.238c-0.089 0-0.16 0.071-0.16 0.16v0 6.88c0 0.089 0.071 0.16 0.16 0.16v0h21.238v2.139c0 0 0 0 0 0 0 0.111 0.090 0.201 0.199 0.201 0.055 0 0.106-0.022 0.142-0.059v0l5.739-5.739c0.036-0.036 0.059-0.086 0.059-0.141s-0.022-0.105-0.059-0.141v0z"
      />
      <path
        fill="#a2df8f"
        opacity="0.15"
        d="M23.066 19.601h-7.157l-3.199-3.6 2.349-3.601 0.807 0.001 7.2 7.2z"
      />
      <path
        fill="#e6e6e6"
        d="M19.591 25.777h-2.24c-0.001-7.827-6.142-13.31-14.951-13.377 0 0 0 0 0 0-0.090 0-0.162 0.071-0.164 0.16v6.88c0 0.001 0 0.003 0 0.005 0 0.085 0.068 0.155 0.154 0.155v0c2.016 0.026 7.765 0.593 7.765 6.177h-2.042c0 0 0 0 0 0-0.111 0-0.201 0.090-0.201 0.201 0 0.055 0.022 0.106 0.059 0.142v0l5.739 5.739c0.036 0.036 0.086 0.059 0.142 0.059s0.106-0.022 0.142-0.059v0l5.739-5.739c0.036-0.036 0.058-0.086 0.058-0.141 0-0.11-0.090-0.199-0.199-0.201v0z"
      />
      <path
        fill="#ff9400"
        d="M19.733 5.881l-5.74-5.739c-0.036-0.036-0.086-0.059-0.142-0.059s-0.106 0.022-0.142 0.059v0l-5.739 5.739c-0.036 0.036-0.059 0.086-0.059 0.142 0 0.111 0.090 0.201 0.201 0.201 0 0 0 0 0 0h2.037c0 5.583-5.749 6.151-7.765 6.177-0.085 0.001-0.154 0.070-0.154 0.155 0 0.002 0 0.003 0 0.005v0 6.88c0.002 0.090 0.075 0.161 0.164 0.161 0.001 0 0.003 0 0.004 0v0c8.814-0.067 14.954-5.55 14.954-13.377h2.24c0.11-0.001 0.198-0.090 0.198-0.201 0-0.055-0.022-0.106-0.060-0.142v0z"
      />
    </SvgIcon>
  );
}

export default CcfAcdIcon;
